(function ($, site, generic, google, addthisevent, tms_page_data) {
  var sortedResults = [];

  site.locator = site.locator || {};
  site.locator.ui = site.locator.ui || {};
  site.locator.data = site.locator.data || {};
  site.locator.geocoder = site.locator.geocoder || {};
  site.locator.map = null; // Google map object
  site.locator.mapDir = null; // Google map object
  site.locator.markers = []; // Array of google.maps.marker objects, ordered the same way as their corresponding doors in site.locator.resultData.results
  site.locator.locationsHtml = []; // Array of HTML snippets for info windows, ordered the same way as their corresponding doors in site.locator.resultData.results
  site.locator.resultData = {}; // contains results from doors query.
  site.locator.resultData.results = []; // contains ordered results from doors query.
  site.locator.infoWindow = null; // google.maps.InfoWindow object
  site.locator.infoWindowDir = null; // google.maps.InfoWindow object
  site.locator.queryFields =
    'DOOR_ID, DOORNAME, EVENT_NAME, EVENT_START_DATE, EVENT_END_DATE, EVENT_IMAGE, EVENT_FEATURES, EVENT_TIMES, SERVICES, STORE_HOURS, ADDRESS, ADDRESS2, STATE_OR_PROVINCE, CITY, REGION, COUNTRY, ZIP_OR_POSTAL, PHONE1, STORE_TYPE, LONGITUDE, LATITUDE';

  site.locator.directionsDisplay = null; // google.maps.DirectionsRenderer object
  site.locator.markerCounter = 0;
  site.locator.travelMode = 'DRIVING';

  site.locator.defaultCountries = '';
  site.locator.defaultDistance = 50;
  site.locator.queryArgs = '';
  site.locator.hiddenFilters = {};
  site.locator.isIntlSearch = false;
  site.locator.appointmentBooking = false;

  site.locator.locationData = site.locator.locationData || {};

  site.locator.ui.getRBs = function () {
    site.locator.rb = {
      view_details: 'view details', // rb.get("view_details"),
      store: 'store', // rb.get("store"),
      address: 'address', // rb.get("address"),
      phone: 'phone', // rb.get("phone"),
      event_js: 'event js', // rb.get("event_js"),
      search_results: 'search results', // rb.get("search_results"),
      no_criteria: 'no criteria', // rb.get("no_criteria"),
      search_error: 'error' // rb.get("search_error")
    };
  };

  site.locator.getDomNodes = function () {
    var $wrapper = $('.js-store-locator');
    var $distanceMenu = $('body').hasClass('device-pc')
      ? $('select.js-distance.distance-filter-pc')
      : $('select.js-distance.distance-filter-mobile');

    site.locator.nodes = {
      container: $wrapper,
      staticDefaultContentArea: $('.js-store-locator-default', $wrapper),
      bodyContainer: $('.js-store-locator-body', $wrapper),
      moreResultsContainer: $('.js-more-results-container', $wrapper),
      moreResultsButton: $('.js-more-results.button', $wrapper),
      heroContainer: $('.js-store-locator__hero-container', $wrapper),
      // prepending 'select' to the beginning of the following selector, so that it grabs ONLY the actual select element
      countryMenu: $('select.js-country', $wrapper),
      localcountryMenu: $('.js-local-country', $wrapper),
      cityMenuIntl: $('.js-city-intl', $wrapper), // how is this different from cityMenu
      stateMenu: $('.js-store-search-controls .js-state', $wrapper),
      cityMenu: $('.js-store-search-controls .js-city', $wrapper),
      doorMenu: $('.js-store-search-controls .js-door', $wrapper),
      doorRows: $('.js-door-row', $wrapper),
      doorWithEventRows: $('.js-door-row', $wrapper),
      doorWithoutEventRows: $('.js-door-row', $wrapper),
      searchInput: $('.js-search', $wrapper),
      selectText: $('.js-locator-select', $wrapper),
      distanceMenu: $distanceMenu,
      searchBtn: $('.js-search-submit', $wrapper),
      searchAltTxt: $('.js-search-alternative-text', $wrapper),
      searchBtnGeo: $('.js-geo-search', $wrapper),
      searchBtnIntl: $('.js-search-submit-intl', $wrapper),
      searchPanel: $('.js-store-search-controls', $wrapper),
      landingPanel: $('.js-locator_landing', $wrapper),
      mapPanel: $('js.locations-map-panel', $wrapper),
      map: $('.js-map-canvas', $wrapper),
      mapContainer: $('.js-map-canvas-container', $wrapper),
      resultsContainer: $('.js-locator-results-container', $wrapper),
      filterControlContainer: $('.js-store-locator__filter-controls', $wrapper),
      filterContainer: $('.js-store-locator-store-filters', $wrapper),
      storeDistanceFilter: $('.js-store-locator-distance-filter', $wrapper),
      storeFilterToggle: $(
        '.js-store-locator__filter-toggle, .js-store-locator-filter-set__close',
        $wrapper
      ),
      storeFilterContainer: $('.js-store-locator-filter', $wrapper),
      storeFilterSet: $('.js-store-locator-filter-set__category-links', $wrapper),
      applyFilterButton: $('.js-filter-submit', $wrapper),
      resetFilterButton: $('.js-reset-filter', $wrapper),
      storeResults: $('.js-store-results', $wrapper),
      locatorErrors: $('.js-locator-error-messages', $wrapper),
      locatorErrorsIntl: $('.js-locator-error-messages-intl', $wrapper),
      dirErrors: $('.js-directions-form-errors', $wrapper),
      dirAddrInput: $('.js-locator-typeahead-input', $wrapper),
      dirCityInput: $('.js-directions-form-city', $wrapper),
      dirStateMenuContainer: $('.js-directions-state-container', $wrapper),
      dirStateMenu: $('.js-directions-form-state', $wrapper),
      dirCountryMenu: $('.js-directions-form-country', $wrapper),
      dirDoorInput: $('.js-directions-form-door', $wrapper),
      dirSubmit: $('.js-directions-submit', $wrapper),
      dirForm: $('.js-directions-form', $wrapper),
      dirResults: $('.js-directions-results', $wrapper),
      dirPanel: $('.js-directions-panel', $wrapper),
      dirMap: $('.js-directions-map-container', $wrapper),
      dirDestination: $('.js-destination', $wrapper),
      dirFromAddr: $('.js-from-address', $wrapper),
      invalidZip: $('.js-locator-invalid-zip', $wrapper),
      missingCityUS: $('.js-locator-missing-city-us', $wrapper),
      missingCityIntl: $('.js-locator-missing-city-intl', $wrapper),
      missingStartAddr: $('.js-locator-missing-start-address', $wrapper),
      dirInvalidAddress: $('.js-locator-dir-invalid-address', $wrapper),
      dirNoRoute: $('.js-locator-dir-no-route', $wrapper),
      dirUnknownError: $('.js-locator-dir-unknown-error', $wrapper),
      dirUOM: $('#locator-form-distance_unit', $wrapper).text(),
      storeQueryFields: $('.js-store-query-fields', $wrapper),
      localRegionIds: $('.js-region-ids', $wrapper),
      intllocalRegionIds: $('.js-intl-region-ids', $wrapper),
      stateContainer: $('.js-state-container', $wrapper),
      localCountryContainer: $('.js-local-country-container', $wrapper),
      locatorInfo: $('.js-store-locator-info', $wrapper),
      mapRecenteringContainer: $('.js-map-recentering-search', $wrapper),
      mapRecenteringButton: $('.js-map-recentering-search-prompt-button', $wrapper),
      paginatorContainer: $('.js-store-locator-paginator', $wrapper),
      paginatorPrevLink: $('.js-paginator-prev-link', $wrapper),
      paginatorNextLink: $('.js-paginator-next-link', $wrapper),
      paginatorLabel: $('.js-paginator-label', $wrapper),
      paginatorCurrPage: $('.js-paginator-current-pg', $wrapper),
      paginatorMaxPage: $('.js-paginator-max-pg', $wrapper),
      buttons: {
        mapActive: $('.js-locator-map-active', $wrapper),
        listActive: $('.js-locator-list-active', $wrapper)
      },
      errors: {
        noSearchTerm: $('.js-locator-error-messages .no-search-term', $wrapper),
        noLocationsFound: $('.js-locator-error-messages .no-locations-found', $wrapper),
        unrecognizedSearchTerm: $('.js-locator-error-messages .unrecognized-searchterm', $wrapper),
        noStoresFound: $('.js-locator-error-messages .no-stores-found', $wrapper)
      },
      toolTipTemplates: $('.location_tooltip_container', $wrapper)
    };

    if (!navigator.geolocation) {
      site.locator.nodes.searchBtnGeo.parent('.form_element').detach();
      site.locator.nodes.searchAltTxt.detach();
    }

    // Defaults
    if (_.isEmpty(site.locator.nodes.dirUOM)) {
      site.locator.nodes.dirUOM = 'mile';
    }

    if (site.locator.nodes.storeQueryFields.length > 0) {
      site.locator.queryFields = site.locator.nodes.storeQueryFields.val();
    }
  };

  _.extend(site.locator.ui, {
    reset: function () {
      site.locator.nodes.searchInput.removeClass('error');
      site.locator.nodes.cityMenu.removeClass('error');
      $.each(site.locator.nodes.errors, function () {
        $(this).addClass('inactive');
      });
    },

    /**
     * This function initializes the UI elements of the Store Locator page.
     * It communicates with site.locator.data via events.
     */
    init: function () {
      site.locator.defaultCountries =
        site.locator.nodes.container.data('default-country') ||
        site.locator.nodes.container.data('local-countries');

      if (site.locator.defaultCountries.indexOf('_') !== -1) {
        var locale = generic.cookie('LOCALE');
        var localCountry = site.locator.defaultCountries.split(',');
        var locale_val = locale.split('_');
        var country_locale_val;

        for (var j = 0; j <= localCountry.length; j++) {
          country_locale_val = localCountry[j].split('_');
          if (locale_val[1] === country_locale_val[1]) {
            site.locator.defaultCountries = country_locale_val[0];
            break;
          }
        }
      }
      //set the appointment booking flag
      site.locator.appointmentBooking =
        parseInt($('.store-locator').attr('data-appointment-booking-enabled')) === 1 ? true : false;
      /*
       * This function takes a select menu, removes its options, then adds an option with name="Default" and value = ""
       */
      var _clearMenu = function (menu) {
        // wipe out menu html
        menu.html('');

        // rebuild
        generic.forms.select.addOption({
          menuNode: menu,
          label: menu.attr('title') ? menu.attr('title') : site.locator.nodes.selectText.text(),
          value: ''
        });
      };
      /*
       * Initializes select menus by adding default option and populating the State menu from JSON data in page
       */
      var _initMenus = function () {
        $([
          site.locator.nodes.countryMenu,
          site.locator.nodes.localcountryMenu,
          site.locator.nodes.cityMenuIntl,
          site.locator.nodes.stateMenu,
          site.locator.nodes.cityMenu,
          site.locator.nodes.doorMenu
        ]).each(function () {
          _clearMenu($(this));
        });

        // Populate the country dropdown for the directions menu
        generic.forms.select.addOption({
          menuNode: site.locator.nodes.dirCountryMenu,
          value: site.locator.defaultCountries
        });
        var country;

        // populate local country select first if visible
        for (country in site.locator.locationData) {
          if (_.isEmpty(country)) {
            continue;
          }
          if (site.locator.defaultCountries.indexOf(country) !== -1) {
            var state;

            if (
              site.locator.nodes.stateContainer.hasClass('neither') ||
              site.locator.nodes.cityMenu.length > 0
            ) {
              // only showing city filter...
              for (state in site.locator.locationData[country]) {
                for (var city in site.locator.locationData[country][state]) {
                  generic.forms.select.addOption({
                    menuNode: site.locator.nodes.cityMenu,
                    value: city
                  });
                }
              }
            } else if (!site.locator.nodes.localCountryContainer.hasClass('state')) {
              // showing local country filter...
              generic.forms.select.addOption({
                menuNode: site.locator.nodes.localcountryMenu,
                value: country
              });
            } else {
              // showing state
              for (state in site.locator.locationData[country]) {
                if (state === '') {
                  continue;
                }
                generic.forms.select.addOption({
                  menuNode: site.locator.nodes.stateMenu,
                  value: state
                });
              }
            }
          } else {
            generic.forms.select.addOption({
              menuNode: site.locator.nodes.countryMenu,
              value: country
            });
            generic.forms.select.addOption({
              menuNode: site.locator.nodes.dirCountryMenu,
              value: country
            });
          }
        }

        site.locator.nodes.countryMenu.val(site.locator.nodes.container.data('default-country'));
        var search = site.locator.ui.getSearchVal();

        site.locator.geocoder.find({
          params: {
            address: search,
            componentRestrictions: { country: country }
          },
          resultFilter: {
            blacklist: true,
            partialBlacklist: true
          }
        });

        // Manually trigger the change handler so that the internation city drop-down gets populated
        _countryMenuChangeHandler(site.locator.nodes.cityMenuIntl);
      };
      var _countryMenuChangeHandler = function (cityNode) {
        var cities = {};

        for (var state in site.locator.locationData[site.locator.nodes.countryMenu.val()]) {
          $.extend(cities, site.locator.locationData[site.locator.nodes.countryMenu.val()][state]);
        }
        _filterCityMenu(cityNode, cities);
        cityNode.focus();
      };
      /*
       * Reads value from state menu and populates city menu with the appropriate values, based on JSON data in page
       */
      var _filterCityMenu = function (cityNode, locationData) {
        _clearMenu(cityNode);

        // retrieve cities from that state, populate city menu
        var cityData = locationData;

        for (var city in cityData) {
          generic.forms.select.addOption({
            menuNode: cityNode,
            value: city
          });
        }

        _clearMenu(site.locator.nodes.doorMenu);
      };
      /*
       * Event handler for click of Doors search button
       */
      var _searchClickHandler = function (intl) {
        intl = typeof intl !== 'undefined' ? intl : false;

        site.locator.ui.reset();
        site.locator.isIntlSearch = intl;

        var country =
          site.locator.nodes.countryMenu.val() ||
          site.locator.nodes.container.data('default-country');
        var search = '';

        // ANR-1337: with the introduction of the following conditional, there's now a bug
        // whereas saved search + internation searches don't play nicely together. Before, it was
        // just assuming 'search' was blank, so there was no issue.
        if (!!intl) {
          search = site.locator.nodes.cityMenuIntl.val();
        } else {
          search = site.locator.ui.getSearchVal();
        }

        if (search === '') {
          // if there's no search term, display an error message, and return early
          site.locator.nodes.errors.noSearchTerm
            .removeClass('inactive')
            .siblings()
            .addClass('inactive');
          site.locator.nodes.locatorErrors.addClass('active');
          site.locator.nodes.searchInput.addClass('error');
          site.locator.nodes.cityMenu.addClass('error');

          return;
        }

        var distance = site.locator.nodes.distanceMenu.val();
        var bps = Unison.fetch.all();
        var bp = Unison.fetch.now();
        var isDesktop = parseInt(bp.width, 10) >= parseInt(bps.landscape, 10);
        // Setting the default country to US for one isn't selected.
        var isUS =
          country.match(/^united states*/i) || $.inArray(country, site.locator.defaultCountries)
            ? true
            : !!(!country || !country.length);

        // add country if not populated and there's only one local country
        if (country === '' && site.locator.defaultCountries.split(',').length === 1) {
          country = site.locator.defaultCountries;
        }

        // get current content from main search text field, and run it through the geocoder
        site.locator.geocoder.find({
          params: { address: search },
          resultFilter: {
            blacklist: true,
            partialBlacklist: true
          },
          successHandler: function (filteredResults, results) {
            // Handle country searches.
            if (!isUS) {
              if (!search) {
                filteredResults = results;
              }
            }

            if (Drupal.settings.common.is_core_site) {
              filteredResults = results;
            }

            if (filteredResults && filteredResults.length > 0) {
              site.locator.ui.searchBaseHandler(
                results[0].geometry.location.lat(),
                results[0].geometry.location.lng(),
                distance,
                country,
                intl
              );

              $(document).on('locator.searchQuerySuccess', function () {
                site.locator.addressDisplayData = results[0].formatted_address;
                site.locator.foundLocationData = results;
                site.locator.remainingLocationData = results.slice(1);
                site.locator.nodes.container
                  .removeClass('store-locator--error')
                  .addClass('store-locator--results');

                Unison.on('change', function (bp) {
                  bp = Unison.fetch.now();
                  isDesktop = parseInt(bp.width, 10) >= parseInt(bps.landscape, 10);
                });
              });
            } else {
              site.locator.nodes.errors.noLocationsFound.removeClass('inactive');
              site.locator.nodes.container.addClass('store-locator--error');
              site.locator.nodes.searchInput.addClass('error');
              site.locator.nodes.cityMenu.addClass('error');
            }
          },
          errorHandler: function () {
            site.locator.nodes.searchInput.addClass('error');
            site.locator.nodes.cityMenu.addClass('error');
            site.locator.nodes.errors.unrecognizedSearchTerm.removeClass('inactive');
          }
        });
      };
      var _searchGeoClickHandler = function () {
        var bps = Unison.fetch.all();
        var bp = Unison.fetch.now();
        var isDesktop = parseInt(bp.width, 10) >= parseInt(bps.landscape, 10);

        site.locator.nodes.container.addClass('loading');

        site.locator.ui.reset();
        site.geo.locate(function (args) {
          var door = site.locator.nodes.doorMenu.val();
          var distance = site.locator.nodes.distanceMenu.val();

          // Setting these manually.
          if (!distance || isNaN(distance)) {
            distance = site.locator.defaultDistance; // Must ensure a minimum radius.
          }

          var storeList = [];

          if (!!door) {
            if (door.length > 0) {
              storeList[0] = door;
              site.locator.queryArgs.params[0].show_stores_list = storeList;
            }
          }

          // find the containing zip code, then send the query
          site.locator.geocoder.find({
            params: { latLng: new google.maps.LatLng(args.lat, args.lng) },
            resultFilter: { whitelist: true },
            successHandler: function (filteredResults, results) {
              site.locator.ui.searchBaseHandler(args.lat, args.lng);

              $(document).off('locator.searchQuerySuccess');
              $(document).on('locator.searchQuerySuccess', function (evt, param) {
                site.locator.queryArgs.addressDisplayData =
                  filteredResults[0].address_components[0].long_name;
                site.locator.nodes.container.addClass('store-locator--results');
              });
              _getReverseGeocodingData(args.lat, args.lng);
            }
          });
        });
      };
      var _getReverseGeocodingData = function (lat, lng) {
        var latlng = new google.maps.LatLng(lat, lng);
        var geocoder = new google.maps.Geocoder();

        geocoder.geocode({ latLng: latlng }, function (results, status) {
          if (status === google.maps.GeocoderStatus.OK) {
            site.locator.nodes.dirAddrInput.val(results[0].formatted_address);
          }
        });
      };
      var _initPlaceAutocomplete = function () {
        site.locator.ui.autocomplete = new google.maps.places.Autocomplete(
          site.locator.nodes.searchInput.get(0)
        );
        if (site.locator.map) {
          site.locator.ui.autocomplete.bindTo('bounds', site.locator.map);
        }

        site.locator.ui.autocomplete.addListener('place_changed', function () {
          var place = this.getPlace(); // btw, this === site.locator.ui.autocomplete, our autocomplete instance

          if (!place.geometry) {
            // make some error message
            return;
          }

          site.locator.ui.searchBaseHandler(
            place.geometry.location.lat(),
            place.geometry.location.lng()
          );
          site.locator.queryArgs.addressDisplayData = place.formatted_address;
        });
      };

      _initMenus();

      site.locator.nodes.countryMenu.on('change', function () {
        _countryMenuChangeHandler(site.locator.nodes.cityMenuIntl);
      });

      site.locator.nodes.searchBtn.on('click', function () {
        _searchClickHandler();
      });

      site.locator.nodes.storeFilterToggle.on('click', function (e) {
        _storeFilterToggleUI();
      });

      site.locator.nodes.storeFilterSet
        .once('js-store-locator-filter-set__click')
        .on('click', '.js-store-locator-filter-set__link', function (e) {
          e.preventDefault();
          $(this).toggleClass('active');
          $(this).find('.filter_store_name').toggleClass('active');
        });

      site.locator.nodes.applyFilterButton.on('click', function () {
        site.locator.ui.storeFilterHandler();
        _storeFilterToggleUI();
      });

      site.locator.nodes.resetFilterButton.on('click', function (e) {
        e.preventDefault();
        site.locator.ui.storeFilterResetHandler();
        _storeFilterToggleUI();
      });

      var _storeFilterToggleUI = function () {
        site.locator.nodes.storeFilterContainer.toggle('slow');
        site.locator.nodes.filterControlContainer.toggleClass('open');
        site.locator.nodes.storeFilterToggle.toggleClass('open');
        $('body').toggleClass('filter-open');
      };

      site.locator.nodes.distanceMenu.on('change', function () {
        if (!$.isEmptyObject(site.locator.resultData.results)) {
          _searchClickHandler();
          _storeFilterToggleUI();
        }
      });

      _searchGeoClickHandler();
      site.locator.nodes.searchBtnGeo.on('click', function (e) {
        e.preventDefault();
        _searchGeoClickHandler();
      });

      site.locator.nodes.container.on('keydown', function (e) {
        if (e.keyCode === 13) {
          e.preventDefault();
          $(event.target).trigger('click');
        }
      });

      site.locator.nodes.searchInput.on('keydown', function (e) {
        if (e.keyCode === 13) {
          _searchClickHandler();
        }
        site.locator.nodes.searchInput.trigger('locator.search.typing', [e.keyCode]);
      });

      if (site.locator.nodes.container.hasClass('place-autocomplete')) {
        _initPlaceAutocomplete();
      }

      site.locator.ui.displayMap();

      // prepopulate search field with form-submitted search value, if we're passed one, then submit
      var presubmittedSearch = {
        all: generic.env.parsedQuery(),
        search: generic.env.parsedQuery().LOCATION,
        lat: generic.env.parsedQuery().LAT,
        lng: generic.env.parsedQuery().LNG
      };

      if (typeof presubmittedSearch.search == 'string') {
        site.locator.nodes.searchInput.val(
          decodeURIComponent(presubmittedSearch.search).replace('+', ' ')
        );
        site.locator.nodes.searchBtn.trigger('click');
      } else if (
        typeof presubmittedSearch.lat == 'string' &&
        typeof presubmittedSearch.lng == 'string'
      ) {
        site.locator.nodes.searchBtnGeo.trigger('click', presubmittedSearch);
      }

      initDirectionsForm();
      initTravelMode();
      site.locator.nodes.buttons.mapActive.on('click', function (e) {
        e.preventDefault();
        site.locator.nodes.buttons.listActive.removeClass('active');
        site.locator.nodes.buttons.mapActive.addClass('active');
        site.locator.nodes.resultsContainer.removeClass('active');
        site.locator.nodes.mapContainer.addClass('active');
      });
      site.locator.nodes.buttons.listActive.on('click', function (e) {
        e.preventDefault();
        site.locator.nodes.buttons.mapActive.removeClass('active');
        site.locator.nodes.buttons.listActive.addClass('active');
        site.locator.nodes.mapContainer.removeClass('active');
        site.locator.nodes.resultsContainer.addClass('active');
      });
      // trigger the event handler above for the active element of the two (to initialize)
      $()
        .add(site.locator.nodes.buttons.mapActive, site.locator.nodes.buttons.listActive)
        .filter('.active:visible')
        .trigger('click');
    },

    /*
     * This function fetches the JS template: /templates/locator/location_info.tmpl
     * and uses it to create the info windows that are displayed when clicking on a pointer image on the map.
     */
    buildLocationHtml: function (args) {
      site.template.get({
        name: 'location_info',
        data: args.locationData,
        callback: function (html) {
          var $htm = $(html);

          if (site.locator.appointmentBooking) {
            var $apptBookLink = $htm.find('.store-locator__tooltip-book-appointment'),
              abHref = $apptBookLink.attr('href');
            if (args.locationData.APPT_BOOK_COUNTER_ID) {
              $apptBookLink.attr(
                'href',
                abHref + '?counter_id=' + args.locationData.APPT_BOOK_COUNTER_ID
              );
            } else {
              $apptBookLink.remove();
            }
          }
          args.callback($htm[0].innerHTML);
        }
      });
    },

    // This funtion filters the json results based on the user's selection of Store/Spa
    buildResult: function (ui, selectedStores) {
      selectedStores = selectedStores || [];
      var tbody = null;

      tbody = site.locator.nodes.storeResults.find('tbody tr td');
      tbody.html('');
      var rowNumber = 0;
      var filteredResults = [];

      site.locator.data.clearMarker(null);
      site.locator.resultData.sortedResults = sortedResults;
      site.locator.markerCounter = 0;

      for (var sortedResult in site.locator.resultData.sortedResults) {
        if (selectedStores.length > 0) {
          if (
            $.inArray(
              site.locator.resultData.sortedResults[sortedResult].DOORNAME,
              selectedStores
            ) !== -1
          ) {
            ui.buildRow(site.locator.resultData.sortedResults[sortedResult], rowNumber, tbody);
            filteredResults[rowNumber] = site.locator.resultData.sortedResults[sortedResult];
            rowNumber++;
          }
        } else {
          ui.buildRow(site.locator.resultData.sortedResults[sortedResult], rowNumber, tbody);
          filteredResults[rowNumber] = site.locator.resultData.sortedResults[sortedResult];
          rowNumber++;
        }
      }
      $(site.locator.nodes.locatorInfo).find('.count').html(rowNumber);
      site.locator.resultData.results = filteredResults;
      site.locator.resultData.sortedResults = filteredResults;
      site.locator.nodes.doorRows = $('.js-door-row');
      ui.displayMap();
      ui.renderPager(rowNumber);
    },

    /*
     * This function builds the row markup for door results
     */
    buildRow: function (doorData, idx, tbody) {
      doorData.index_number = idx;
      doorData.display_number = idx + 1;
      doorData.distanceFormatted = parseFloat(doorData.DISTANCE).toFixed(2);
      doorData.distanceFormatted = isNaN(doorData.distanceFormatted)
        ? 'Unknown'
        : doorData.distanceFormatted;

      if (doorData.EVENT_START_DATE && doorData.EVENT_END_DATE) {
        var event_start = new Date(doorData.EVENT_START_DATE.replace(/-/g, ' '));
        var event_end = new Date(doorData.EVENT_END_DATE.replace(/-/g, ' '));

        // PBruno: the check for the year has to  do with JS 1.2 backwards compatibility,
        // which would in some instances spit out a four-digit full year, for all
        // years not in 1900-1999; I just check for any four digit value for year,
        // and if I find one, leave it alone (forego adding the 1900)
        doorData.EVENT_DATE =
          event_start.getMonth() +
          1 +
          '/' +
          event_start.getDate() +
          '/' +
          (event_start.getYear() < 1000
            ? parseInt(event_start.getYear()) + 1900
            : event_start.getYear());
        doorData.EVENT_DATE += ' - ';
        doorData.EVENT_DATE +=
          event_end.getMonth() +
          1 +
          '/' +
          event_end.getDate() +
          '/' +
          (event_end.getYear() < 1000 ? parseInt(event_end.getYear()) + 1900 : event_end.getYear());

        if (doorData.EVENT_IMAGE) {
          var image_path_parts = doorData.EVENT_IMAGE.split('.');

          image_path_parts[0] += '_lrg';
          doorData.EVENT_LARGE_IMAGE = image_path_parts.join('.');
        }
      }
      // Display store hours
      if (typeof doorData.STORE_HOURS === 'object' && doorData.STORE_HOURS !== null) {
        doorData.parsed_hours = '';
        for (var s = 0; s < doorData.STORE_HOURS.length; s++) {
          var hours = doorData.STORE_HOURS[s].hours || '';

          hours = hours.trim();
          hours = hours.replace(/ /g, '&nbsp;');
          doorData.parsed_hours += '<div class="store-locator__each-day">';
          doorData.parsed_hours += '  <span class="store-locator__day--name">';
          doorData.parsed_hours += doorData.STORE_HOURS[s].day + '</span>';
          doorData.parsed_hours += '  <span class="store-locator__day--hours">' + hours + '</span>';
          doorData.parsed_hours += '</div>';
        }
      }

      site.template.get({
        name: 'door_row',
        data: doorData,
        callback: function (html) {
          var idx = doorData.index_number;
          var node = $(html);

          if (doorData.COUNTRY !== site.locator.defaultCountry) {
            node.find('.directions').hide();
          }
          tbody.append(node);
          var row = tbody.find('.door_row_' + idx);
          var $storeDiv = $('.store-locator__tooltip');
          var $doorRows = $('.js-door-row');
          var $classificationTitle = row.find('.store-locator__tooltip-classification');
          var $productTypes = row.find('.store-locator__tooltip-product-types .pc');
          var $storeHours = row.find('.store-locator__tooltip-hours');
          var $toolTipCollection = $classificationTitle.add($productTypes);

          // Assume first store is shown in map
          $('.door_row_0').addClass('active');

          site.locator.nodes.doorRows.add(row);
          var hasEvent = true;

          if (hasEvent) {
            site.locator.nodes.doorWithEventRows.add(row);
          } else {
            row.find('.event-details > *').css('display', 'none');
            site.locator.nodes.doorWithoutEventRows.add(row);
          }
          if (site.locator.appointmentBooking) {
            var $apptBookLink = node.find('.store-locator__tooltip-book-appointment'),
              abHref = $apptBookLink.attr('href');
            if (doorData.APPT_BOOK_COUNTER_ID) {
              $apptBookLink.attr('href', abHref + '?counter_id=' + doorData.APPT_BOOK_COUNTER_ID);
            } else {
              $apptBookLink.remove();
            }
          }
          row.on('click', function () {
            site.locator.ui.launchInfoWindow(idx);
            row.addClass('active');
          });

          $storeHours.on('click', function () {
            $(this).toggleClass('active');
          });

          $doorRows.on('click', function () {
            $doorRows.removeClass('active');
            $(this).addClass('active');
          });

          if ($(site.locator.nodes.toolTipTemplates.selector).length !== 0) {
            var $templates = $(site.locator.nodes.toolTipTemplates.selector);

            $toolTipCollection.tooltipster({
              animation: 'fade',
              arrow: true,
              contentAsHTML: true,
              interactive: true,
              position: 'top',
              speed: 500,
              theme: 'tooltipster-toofaced',
              trigger: !site.client.isMobile ? 'hover' : 'click' /** for mobile we may use click */,
              updateAnimation: false,
              functionBefore: function (instance, helper) {
                if (!$(instance).data('tooltipContent')) {
                  var matched_dom = '';
                  var title_text = $(instance).text().toLowerCase();

                  $templates.find('.tooltip_container--header').each(function () {
                    if (
                      $(this).text().toLowerCase() === title_text ||
                      title_text === $(this).parent().data('key')
                    ) {
                      matched_dom = $(this).parent();
                    }
                  });
                  $(instance).data('tooltipContent', matched_dom);
                }
                if ($(instance).data('tooltipContent').length > 0) {
                  helper();
                  instance.tooltipster('content', $(instance).data('tooltipContent'));
                }
              }
            });
          }
          generic.overlay.initLinks();

          // offer directions via google page
          site.locator.ui.directionsLink(row, doorData);

          var directionsLink = $('a.directions_link').eq(idx);

          directionsLink.on('click', function (evt) {
            evt.preventDefault();
            initDirectionsForm();
            site.template.get({
              name: 'destination_address',
              data: doorData,
              callback: function (html) {
                site.locator.nodes.dirDestination.html(html);
              }
            });

            site.locator.nodes.dirDoorInput.val(doorData.DOOR_ID);
          });

          // Make sure 'Book Now' buttons open a new window
          $('.js-store-locator-book-now', row).attr('target', '_blank');
        }
      });
    },

    displayStoreFilter: function () {
      var filterStoreHtml = '';

      if (site.locator.resultData.filterStoreNames.length > 0) {
        $.each(site.locator.resultData.filterStoreNames, function (key, value) {
          filterStoreHtml +=
            '<a href="#" class="filter-link store-locator-filter-set__link js-store-locator-filter-set__link" data-store-filter="' +
            value +
            '" tabindex="3"><div class="filter-link__text store-locator-filter-set__link__text"><span class="filter_store_name">' +
            value +
            '</span><svg role="img" aria-hidden="true" class="icon icon--heart--filled"><use xlink:href="#heart--filled"></use></svg></div></a>';
        });
        site.locator.nodes.filterContainer.html(filterStoreHtml);
      }
      site.locator.nodes.storeFilterContainer.hide();
      site.locator.nodes.filterControlContainer.removeClass('open');
      site.locator.nodes.storeFilterToggle.removeClass('open');
      $('body').removeClass('filter-open');
    },

    storeFilterHandler: function () {
      var selectedStores = [];

      $.each(site.locator.nodes.filterContainer.find('a.active'), function () {
        selectedStores.push($(this).attr('data-store-filter'));
      });
      var ui = site.locator.ui;

      ui.buildResult(ui, selectedStores);
    },

    storeFilterResetHandler: function () {
      $.each(site.locator.nodes.filterContainer.find('a.active'), function () {
        $(this).removeClass('active');
      });
      var ui = site.locator.ui;

      ui.buildResult(ui);
    },

    /*
     * This function builds the table of result data. It loads the JS template: /templates/locator/door_row.tmpl.
     * The site.locator.resultData.results Array must be populated.
     */
    displayResultsTable: function () {
      var tbody = null,
        ui = this;

      site.template.get({
        name: 'doors_table',
        data: {},
        callback: function (html) {
          site.locator.nodes.storeResults.html(html);
          tbody = site.locator.nodes.storeResults.find('tbody tr td');
          var searchQuery;
          var totalResults;

          if (site.locator.queryArgs.params !== undefined && site.locator.queryArgs.params.length) {
            totalResults = site.locator.resultData.sortedResults.length;
            var params = site.locator.queryArgs.params[0];
            var searchCriteria = [];
            var paramKeys = ['state', 'city'];

            if (site.locator.addressDisplayData) {
              searchCriteria.push(site.locator.addressDisplayData);
              site.locator.addressDisplayData = null;
            } else if (params.zip !== '' && params.zip !== undefined) {
              searchCriteria.push(params.zip);
            } else if (site.locator.queryArgs.addressDisplayData) {
              searchCriteria.push(site.locator.queryArgs.addressDisplayData);
            } else {
              for (var i = 0; i < paramKeys.length; i++) {
                var paramKey = paramKeys[i];

                if (params[paramKey] !== undefined) {
                  searchCriteria.push(params[paramKey]);
                }
              }
            }
            searchQuery = searchCriteria.join(' ').trim();

            if (totalResults > 0) {
              site.locator.nodes.bodyContainer.removeClass('hidden');
              site.locator.nodes.resultsContainer.removeClass('hidden');
              site.locator.nodes.locatorInfo.removeClass('hidden');
              site.locator.nodes.storeResults.removeClass('hidden');
              site.locator.nodes.storeFilterToggle.removeClass('hidden');
              site.locator.nodes.storeDistanceFilter.removeClass('hidden');
            }

            var $resultCountNode =
                totalResults === 1 ? $('.results-count-singular') : $('.results-count-plural'),
              $otherCountNode =
                totalResults === 1 ? $('.results-count-plural') : $('.results-count-singular'),
              resultCountText =
                totalResults === 1
                  ? $('#locator-results-count-singular').text()
                  : $('#locator-results-count-plural').text();

            $resultCountNode
              .html(
                resultCountText
                  .replace('::count::', '<span class="count">' + totalResults + '</span>')
                  .replace('::query::', '<span class="query">' + searchQuery + '</span>')
              )
              .show();
            $otherCountNode.hide();
          }

          var index = 0;

          for (var sortedResult in site.locator.resultData.sortedResults) {
            ui.buildRow(site.locator.resultData.sortedResults[sortedResult], index, tbody);
            index += 1;
          }

          // Rows were built recently
          site.locator.nodes.doorRows = $('.js-door-row');
          site.locator.ui.renderPager(index);
          addthisevent.refresh();

          var omnidata = [searchQuery, totalResults];

          if (!!tms_page_data && !!tms_page_data.tms_page_info) {
            tms_page_data.tms_page_info.STORELOCATOR = omnidata;
          }
          $(window).trigger('STORELOCATOR', [omnidata]);
        }
      });
    },

    /*
     * Collects parameters from form input elements, packs them into parameters,
     * then passes them to search query via the 'locator:submitSearchQuery' event.
     * @see site.locator.data.submitQuery
     */

    searchBaseHandler: function (lat, lng, distance, country, intl) {
      intl = typeof intl !== 'undefined' ? intl : false;
      var customRadius = site.locator.nodes.container.data('custom-store-radius');
      var radius = customRadius ? customRadius : distance;
      var currentCityVal =
        site.locator.nodes.cityMenu.val() || site.locator.nodes.container.data('default-country');
      // Base query parameters
      var queryArgs = {
        params: [
          {
            fields: site.locator.queryFields,
            radius: radius || site.locator.nodes.distanceMenu.val(),
            country: country || site.locator.nodes.container.data('default-country'),
            latitude: lat,
            longitude: lng,
            uom: site.locator.nodes.dirUOM
          }
        ]
      };

      if (currentCityVal && site.locator.nodes.container.hasClass('js-pass-city')) {
        queryArgs.params[0].city = currentCityVal;
      }

      if (site.locator.nodes.container.data('region-id') !== '') {
        queryArgs.params[0].region_id = site.locator.nodes.container.data('region-id');
      }

      if (!!site.locator.nodes.container.data('language-id')) {
        queryArgs.params[0].language_id = site.locator.nodes.container.data('language-id');
      }

      // Add intl city for intl requests
      if (intl) {
        // cityMenuIntl
        if (!_.isEmpty(site.locator.nodes.cityMenuIntl.val())) {
          queryArgs.params[0]['city'] = site.locator.nodes.cityMenuIntl.val();
        }
      }

      queryArgs.callback = function () {
        site.locator.ui.displayMap();
        site.locator.ui.displayResultsTable();
        site.locator.ui.displayStoreFilter();
      };

      $(document).trigger('locator.submitSearchQuery', [queryArgs]);

      site.locator.queryArgs = queryArgs;
    },

    // To fetch the search text value based on the CMS update by either city/free text
    getSearchVal: function () {
      var search = '';
      var cityVal = site.locator.nodes.cityMenu.length > 0 ? site.locator.nodes.cityMenu.val() : '';
      var searchTextVal =
        site.locator.nodes.searchInput.length > 0
          ? site.locator.nodes.searchInput
              .val()
              .replace(site.locator.nodes.searchInput.attr('placeholder'), '')
              .trim()
          : '';

      if (site.locator.isIntlSearch) {
        search = site.locator.nodes.cityMenuIntl.val();
      } else {
        search = searchTextVal || cityVal;
      }

      return search;
    },

    initMapRecenteringSearch: function () {
      site.locator.nodes.mapRecenteringContainer.addClass('hidden');
      site.locator.map.addListener('dragend', function () {
        var lat = this.getCenter().lat(),
          lng = this.getCenter().lng();

        site.locator.nodes.mapRecenteringButton.off('click').on('click', function () {
          site.locator.ui.searchBaseHandler(lat, lng, site.locator.defaultDistance);
          site.locator.nodes.mapRecenteringContainer.addClass('hidden');
          var latlng = new google.maps.LatLng(lat, lng);
          var geocoder = new google.maps.Geocoder();

          geocoder.geocode({ latLng: latlng }, function (results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
              site.locator.nodes.dirAddrInput.val(results[0].formatted_address);
            }
          });
        });
        site.locator.nodes.mapRecenteringContainer.removeClass('hidden');
      });
    },

    /*
     * This function encapsulates the various calls to the Google Maps API that render
     * the map of results. It initializes a google.maps.Map object (storing it in site.locator.map),
     * adds markers, and sets up the event handler for clicking on the markers.
     * The site.locator.resultData.results Array must be populated.
     */
    displayMap: function (directions, i) {
      var results = i === 0 || i ? [i] : site.locator.resultData.results;
      var mapNode = directions ? site.locator.nodes.dirMap : site.locator.nodes.map;
      var mapOptions = {
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: false,
        navigationControl: true,
        mapTypeControl: false,
        scrollwheel: false,
        scaleControl: true,
        streetViewControl: false
      };
      var map = new google.maps.Map(mapNode[0], mapOptions);

      // if there are no results, center the map on the US, display the map, and just return
      if (!results || results.length === 0) {
        mapOptions.zoom = 7;

        var geocoder = new google.maps.Geocoder();
        var country = site.locator.defaultCountries || 'US';

        site.locator.map = map;

        geocoder.geocode({ address: country }, function (results, status) {
          var ne = results[0].geometry.viewport.getNorthEast();
          var sw = results[0].geometry.viewport.getSouthWest();

          map.fitBounds(results[0].geometry.viewport);
        });
        mapNode.show();

        return;
      }

      // if we're here, there is result data, proceed accordingly
      mapOptions.zoom = directions ? 15 : 12;
      mapOptions.center = new google.maps.LatLng(
        site.locator.resultData.latitude,
        site.locator.resultData.longitude
      );

      map = new google.maps.Map(mapNode[0], mapOptions);

      if (directions) {
        site.locator.mapDir = map;
      } else {
        site.locator.map = map;
      }

      mapNode.show();

      if (site.locator.nodes.container.hasClass('map-recentering-search')) {
        site.locator.ui.initMapRecenteringSearch();
      }

      var location;
      var latLng;
      var marker;

      if (!directions) {
        var idx = 0;

        for (var result in results) {
          // place markers on Google Map
          location = site.locator.resultData.sortedResults[idx];
          latLng = new google.maps.LatLng(location.LATITUDE, location.LONGITUDE);

          marker = site.locator.MapLocationIcon({
            id: '',
            latlng: latLng,
            icon_class: 'store-locator__result-pin',
            htmlContent:
              '<span class="store-locator__result-pin-label result-number js-map-icon-' +
              idx +
              '" data-door-id="' +
              location.DOOR_ID +
              '">' +
              (idx + 1) +
              '</span>',
            map: map,
            dataAttrs: [
              {
                key: 'store-id',
                value: location.DOORNAME.toUpperCase()
              },
              {
                key: 'door-id',
                value: location.DOOR_ID
              }
            ],
            clickHandler: (function (idx, location) {
              return function () {
                site.locator.nodes.container.addClass('detail-view');
                $('.store-locator__result-pin-label')
                  .removeClass('active')
                  .filter("[data-door-id='" + location.DOOR_ID + "']")
                  .addClass('active');

                site.locator.ui.launchInfoWindow(idx);
                site.locator.ui.renderPager(site.locator.resultData.count, idx);
              };
            })(idx, location)
          });

          site.locator.markers[idx] = marker;
          //
          // build info window
          location.idx = idx;
          location.distanceFormatted = parseFloat(location.DISTANCE).toFixed(2);
          location.display_number = idx + 1;
          site.locator.ui.buildLocationHtml({
            locationData: location,
            callback: function (html) {
              site.locator.locationsHtml[idx] = html;
            }
          });

          google.maps.event.addListener(marker, 'click', function () {
            site.locator.ui.launchInfoWindow(idx);
          });

          // set map center for first location
          if (idx === 0) {
            map.setCenter(latLng);
          }
          idx++;
        }

        // display info window on first location (they're zero-indexed)
        $('.js-map-icon-0').addClass('active');
        site.locator.ui.launchInfoWindow(0);
      } else {
        location = site.locator.resultData.sortedResults[i];
        latLng = new google.maps.LatLng(location.LATITUDE, location.LONGITUDE);
        marker = new google.maps.Marker({
          icon: '',
          map: map,
          position: latLng
        });
        map.setCenter(latLng);
      }
    },

    /*
     * Displays Info Window for a given marker/door.
     * @param i {Number} index of door/marker for which info window should be displayed
     */
    launchInfoWindow: function (i) {
      $('.store-locator__result-pin-label').removeClass('active');
      $('.js-map-icon-' + i).addClass('active');
      site.locator.nodes.doorRows.removeClass('active');
      $('.door_row_' + i).addClass('active');
      var location = site.locator.resultData.sortedResults[i];
      var map = site.locator.map;
      var setOffset = function (infoWindow, marker) {
        // get the height of the pin, to make sure the info window clears it
        infoWindow.setOptions({
          pixelOffset: new google.maps.Size(0, $(marker.div).height() * -1)
        });
      };
      var prevOnAddHandler;

      if (!site.locator.infoWindow) {
        site.locator.infoWindow = new google.maps.InfoWindow();
      }
      var infoWindow = site.locator.infoWindow;
      var infoWindowContent = document.createElement('div');

      infoWindowContent.innerHTML = site.locator.locationsHtml[i];
      site.locator.ui.directionsLink(infoWindowContent, location);

      infoWindow.setContent(infoWindowContent);

      var marker = site.locator.markers[i];

      if (!!marker) {
        if (marker.added) {
          setOffset(infoWindow, marker);
        } else {
          prevOnAddHandler = marker.onAddHandler;
          marker.onAddHandler = function () {
            if (prevOnAddHandler) {
              prevOnAddHandler.call(this);
            }
            setOffset(infoWindow, marker);
          };
        }

        // *
        // START INFOWINDOW CUSTOMIZE.
        // The google.maps.event.addListener() event expects
        // the creation of the infowindow HTML structure 'domready'
        // and before the opening of the infowindow, defined styles are applied.
        // *
        google.maps.event.addListener(infoWindow, 'domready', function () {
          // Reference to the DIV that wraps the bottom of infowindow
          var iwOuter = $('.gm-style-iw');
          /* Since this div is in a position prior to .gm-div style-iw.
           * We use jQuery and create a iwBackground variable,
           * and took advantage of the existing reference .gm-style-iw for the previous div with .prev().
           */
          var iwBackground = iwOuter.prev();

          // Removes background shadow DIV
          iwBackground.children(':nth-child(2)').css({ display: 'none' });

          // Add Background Color to white background DIV
          iwBackground.children(':nth-child(4)').css({ 'background-color': '#ffffff' });

          // Moves the arrow 76px to the left margin.
          iwBackground.children(':nth-child(3)').attr('style', function (i, s) {
            return s + 'background-color: #ffffff;';
          });

          // Changes the desired tail shadow color.
          iwBackground.children(':nth-child(3)').find('div').children().css({
            'background-color': '#ffffff',
            'box-shadow': 'none',
            'z-index': '1'
          });

          // Reference to the div that groups the close button elements.
          var iwCloseBtn = iwOuter.next();

          // Apply the desired effect to the close button
          iwCloseBtn.css({
            height: '14px',
            opacity: '0',
            right: '15px',
            top: '13px',
            width: '14px'
          });

          // Hide close button image
          iwCloseBtn.children().css({
            display: 'none'
          });

          // The API automatically applies 0.7 opacity to the button after the mouseout event. This function reverses this event to the desired value.
          iwCloseBtn.on('mouseout', function () {
            $(this).css({ opacity: '1' });
          });
        });

        infoWindow.open(map, marker);
        map.setCenter(marker.position);

        // Random helper function to glom the address pieces together
        var _implode = function (glue, pieces) {
          var i = '';
          var retVal = '';
          var tGlue = '';

          if (arguments.length === 1) {
            pieces = glue;
            glue = '';
          }

          if (typeof pieces === 'object') {
            if (Object.prototype.toString.call(pieces) === '[object Array]') {
              return pieces.join(glue);
            }
            for (i in pieces) {
              retVal += tGlue + pieces[i];
              tGlue = glue;
            }

            return retVal;
          }

          return pieces;
        };

        // set the 'to' address every time a location is highlighted...
        if (location) {
          var li = _implode(' ', [
            'location.ADDRESS',
            'location.ADDRESS2',
            'location.CITY',
            'location.STATE_OR_PROVINCE',
            'location.ZIP_OR_POSTAL',
            'location.COUNTRY'
          ]);

          $('#to_address').val(li);
        }

        // clear out any directions layer and results
        site.locator.directionsDisplay =
          site.locator.directionsDisplay === null
            ? new google.maps.DirectionsRenderer()
            : site.locator.directionsDisplay;
        site.locator.directionsDisplay.setMap(null);
        site.locator.nodes.dirResults.empty();
        $('.store-locator__directions-start, .store-locator__directions-end')
          .addClass('hidden')
          .find('.address')
          .html('');
        site.locator.markerCounter++;
      }
    },

    directionsLink: function (row, doorData) {
      $('.js-directions-link', row).on('click', function (e) {
        e.stopPropagation();
        // Using the store name and address rather than lat/long to get a better marker when landing on the Google site - per Alicia request MAC-975
        if (site.locator.nodes.container.hasClass('directions_lat_long')) {
          window.open(
            'https://www.google.com/maps/dir//' +
              doorData.LATITUDE +
              ',' +
              doorData.LONGITUDE +
              '/',
            '_blank'
          );
        } else {
          window.open(
            'http://maps.google.com/maps?daddr=' +
              encodeURIComponent(
                doorData.DOORNAME +
                  ', ' +
                  doorData.ADDRESS +
                  ', ' +
                  doorData.ADDRESS2 +
                  ', ' +
                  doorData.CITY +
                  ', ' +
                  doorData.STATE_OR_PROVINCE +
                  ', ' +
                  doorData.COUNTRY +
                  ', ' +
                  doorData.ZIP_OR_POSTAL
              ),
            '_blank'
          );
        }

        return false;
      });
    },

    /*
     * Callback function for 'locator:directionsLoaded' event.
     * Hides Directions form and displays Directions results table.
     * Passes directions query response to google.maps.DirectionsRenderer object.
     * @param response {Object} response from Google Maps directions query
     */
    displayDirections: function (response) {
      $('.store-locator__directions-start .address')
        .html(response.routes[0].legs[0].start_address)
        .parent()
        .removeClass('hidden');
      $('.store-locator__directions-end .address')
        .html(response.routes[0].legs[0].end_address)
        .parent()
        .removeClass('hidden');
      site.locator.directionsDisplay.setDirections(response);
    },

    resetDirections: function () {
      site.locator.nodes.dirForm.removeClass('hidden');
      site.locator.nodes.dirResults.addClass('hidden');
    },

    /*
     * Render the pager.
     */
    renderPager: function (totalResults, storeIndex) {
      storeIndex = storeIndex || 0;
      site.locator.storesPerPage = site.locator.nodes.container.data('stores-per-page')
        ? site.locator.nodes.container.data('stores-per-page')
        : 5;
      var currentPage = 1;
      var rowStart;
      var rowEnd;

      if (totalResults > site.locator.storesPerPage) {
        var numPages = Math.ceil(totalResults / site.locator.storesPerPage);
        var $rows = site.locator.nodes.doorRows;
        var $paginatorData = site.locator.nodes.paginatorContainer;
        var $paginatorCurrPage = site.locator.nodes.paginatorCurrPage;

        $paginatorData.attr('data-page-count', numPages);

        storeIndex += 1;
        if (storeIndex < site.locator.storesPerPage) {
          currentPage = 1;
          rowStart = 0;
          rowEnd = site.locator.storesPerPage;
        } else {
          currentPage = Math.ceil(storeIndex / site.locator.storesPerPage);
          rowStart = (currentPage - 1) * site.locator.storesPerPage;
          rowEnd = currentPage * site.locator.storesPerPage;
        }
        $rows.hide().slice(rowStart, rowEnd).show().first().addClass('first');
        site.locator.nodes.paginatorContainer.removeClass('hidden');
        site.locator.nodes.paginatorCurrPage.text(currentPage);
        site.locator.nodes.paginatorMaxPage.text(numPages);
        $paginatorCurrPage.attr('data-curr-page', currentPage);

        site.locator.nodes.paginatorPrevLink.off('click').on('click', function (e) {
          currentPage = +$paginatorCurrPage.attr('data-curr-page');
          numPages = +$paginatorData.attr('data-page-count');
          if (currentPage > 1) {
            currentPage--;
            rowStart = (currentPage - 1) * site.locator.storesPerPage;
            rowEnd = rowStart + site.locator.storesPerPage;
            $rows.hide().slice(rowStart, rowEnd).show();
            site.locator.nodes.paginatorCurrPage.text(currentPage);
            $paginatorCurrPage.attr('data-curr-page', currentPage);
          }
        });

        site.locator.nodes.paginatorNextLink.off('click').on('click', function (e) {
          currentPage = +$paginatorCurrPage.attr('data-curr-page');
          numPages = +$paginatorData.attr('data-page-count');
          if (currentPage < numPages) {
            currentPage++;
            rowStart = (currentPage - 1) * site.locator.storesPerPage;
            rowEnd = rowStart + site.locator.storesPerPage;
            $rows.hide().slice(rowStart, rowEnd).show().first().addClass('first');
            site.locator.nodes.paginatorCurrPage.text(currentPage);
            $paginatorCurrPage.attr('data-curr-page', currentPage);
          }
        });
      } else {
        site.locator.nodes.paginatorContainer.addClass('hidden');
      }
    }
  });

  _.extend(site.locator.data, {
    /*
     * This function handles the query submit event. It parses the data from the event memo
     * and passes it to the fetch method. This method should NOT be called directly by a UI method;
     * rather, the params should be passed as part of the memo to the locator:submitSearchQuery event.
     * @param {function} args.callback a function that gets called after door data is returned
     * @param {Array} args.params an Array that contains a hash of parameters that get
     * passed to the JSON-RPC method.
     * @param {Array} args.params[0].fields The data fields to be returned from the JSON-RPC request
     * @param {number} args.params[0].radius The distance from the origin point inside which stores should be returned.
     * @param {string} args.params[0].zip Postal Code of origin point location
     * @param {string} args.params[0].state State of origin point location
     * @param {string} args.params[0].city City of origin point location
     * @param {Array} args.params[0].show_stores_list Array of Store Names by which results should be filtered. Empty array
     * should be passed to return all stores.
     * @example
     * // var queryArgs = {
     * //     params : [{
     * //         fields : "DOOR_ID, DOORNAME, STORE_HOURS, ADDRESS, ADDRESS2, STATE_OR_PROVINCE, CITY",
     * //         radius : 25,
     * //         zip    : "10014",
     * //         state  : "NY",
     * //         city   : "New York"
     * //     }],
     * //     callback : function() {
     * //          site.locator.ui.displayMap();
     * //          site.locator.ui.displayResultsTable();
     * //      }
     * // };
     */
    submitQuery: function (args) {
      var params = args.params;
      var callbackFn = args.callback;

      if (!params[0].latitude && !params[0].longitude) {
        $.each(site.locator.nodes.errors, function () {
          this.addClass('inactive');
        });
        site.locator.nodes.errors.noLocationsFound.removeClass('inactive');

        return;
      }

      site.locator.data.fetch({
        data: params,
        onSuccess: function (resultData, countersData) {
          $.each(site.locator.nodes.errors, function () {
            this.addClass('inactive');
          });
          site.locator.nodes.container.removeClass('store-locator--error');
          // if no results were found...
          if (resultData.count === 0) {
            site.locator.nodes.errors.noStoresFound.removeClass('inactive');
            site.locator.nodes.container.addClass('store-locator--error');
            site.locator.nodes.filterControlContainer.removeClass('open');
            site.locator.nodes.storeFilterToggle.removeClass('open');
            $('body').removeClass('filter-open');
            site.locator.nodes.resultsContainer.addClass('hidden');
          }
          resultData.maxDistance = parseFloat(args.params[0].radius);
          if (isNaN(resultData.maxDistance)) {
            resultData.maxDistance = null;
          }
          if (site.locator.appointmentBooking) {
            for (var i = 0, len = countersData.length; i < len; i += 1) {
              var cData = countersData[i],
                res = resultData.results[cData.store_no];
              if (res) {
                res.APPT_BOOK_COUNTER_ID = cData.id;
              }
            }
          }

          site.locator.data.setData(resultData);
          if (typeof callbackFn === 'function') {
            callbackFn();
          }

          $(document).trigger('locator.searchQuerySuccess');
        },
        onFailure: function () {
          $.each(site.locator.nodes.errors, function () {
            this.addClass('inactive');
          });
          site.locator.nodes.errors.noStoresFound.removeClass('inactive');
          site.locator.nodes.container.addClass('store-locator--error');

          $(document).trigger('locator.searchQueryFailure');
        }
      });
    },

    /*
     * Callback function that handles response from JSON-RPC request. It filters
     * and sorts the result data, then places the data in the global variable
     * site.locator.resultData.results
     */
    fetch: function (args) {
      generic.jsonrpc.fetch({
        method: 'locator.doorsandevents',
        params: args.data,
        onSuccess: function (r) {
          var resultData = r.getValue();
          if (site.locator.appointmentBooking) {
            generic.jsonrpc.fetch({
              method: 'appointmentbooking.getauthtoken',
              onSuccess: function (rpc) {
                var token = rpc.getValue().auth_token;
                $.ajax({
                  url: 'https://' + window.location.hostname + '/_abapi/api/v1/counters',
                  type: 'GET',
                  data: { token: token, lite: 1 },
                  success: function (counters) {
                    args.onSuccess(resultData, counters);
                  },
                  error: function () {
                    args.onSuccess(resultData, {});
                  }
                });
              },
              onError: function (rpc) {
                //console.log("Error getting authorization token");
              }
            });
          } else {
            args.onSuccess(resultData, {});
          }
        },
        onFailure: function (r) {
          args.onFailure(r);
        }
      });
    },

    /*
     * Callback function that handles response from JSON-RPC request. It filters
     * and sorts the result data, then places the data in the global variable
     * site.locator.resultData.results
     */
    setData: function (rawResultData) {
      site.locator.resultData = rawResultData;
      var refineStoresByInput = site.locator.nodes.container.hasClass('js-refine-stores');
      var searchVal = site.locator.ui.getSearchVal();
      var doorsData = [];
      var doorsCount = 0;
      var filterStoreNames = [];

      if (rawResultData.maxDistance) {
        // max distance exists
        var filteredResults = {};

        for (var rawValue in rawResultData.results) {
          if (rawResultData.results[rawValue].DISTANCE < rawResultData.maxDistance) {
            if (refineStoresByInput && site.locator.nodes.cityMenu.length > 0) {
              if (rawResultData.results[rawValue].CITY === searchVal) {
                filteredResults[rawValue] = rawResultData.results[rawValue];
                doorsData.push(rawValue);
                doorsCount += 1;
              }
            } else {
              filteredResults[rawValue] = rawResultData.results[rawValue];
            }
          }
          filterStoreNames.push(filteredResults[rawValue].DOORNAME.trim());
        }
        if (refineStoresByInput && site.locator.nodes.cityMenu.length > 0) {
          site.locator.resultData.count = doorsCount;
          site.locator.resultData.doors = doorsData;
        }
        site.locator.resultData.results = filteredResults;
        site.locator.resultData.filterStoreNames = _.uniq(filterStoreNames).sort();
      }

      // asc. sort by distance
      sortedResults = [];
      var r = site.locator.resultData.results;
      var sortedDoorIds = site.locator.resultData.doors || [];

      function sortByDistance(a, b) {
        var aDist = !r[a].DISTANCE || isNaN(r[a].DISTANCE) ? 0 : parseFloat(r[a].DISTANCE);
        var bDist = !r[b].DISTANCE || isNaN(r[b].DISTANCE) ? 0 : parseFloat(r[b].DISTANCE);

        if (aDist > bDist) {
          return 1;
        } else if (aDist < bDist) {
          return -1;
        }

        return 0;
      }

      sortedDoorIds.sort(sortByDistance);

      for (var index = 0, len = sortedDoorIds.length; index < len; index++) {
        sortedResults.push(site.locator.resultData.results[sortedDoorIds[index]]);
      }
      site.locator.resultData.sortedResults = sortedResults;
    },

    // Clears past markers
    clearMarker: function (map) {
      for (var index = 0; index < site.locator.markers.length; index++) {
        site.locator.markers[index].setMap(map);
      }
    },

    /*
     * This function retrieves Driving Directions data from Google. The data
     * retrieved is then passed as a memo in the event 'locator:directionsLoaded.'
     */
    getDirections: function () {
      var directionsService = new google.maps.DirectionsService();

      site.locator.directionsDisplay =
        site.locator.directionsDisplay === null
          ? new google.maps.DirectionsRenderer()
          : site.locator.directionsDisplay;

      site.locator.nodes.dirResults.empty();
      site.locator.directionsDisplay.setMap(null);

      site.locator.directionsDisplay.setMap(site.locator.map);
      site.locator.directionsDisplay.setPanel($('.directions-form__results').get(0));
      site.locator.directionsDisplay.setOptions({
        markerOptions: {
          icon: '/media/images/locator/icons/pink_A.png'
        }
      });

      var start = $('#from_address').val();
      var end = $('#to_address').val(); // args.doorData.ADDRESS + ", " + args.doorData.CITY + " " + args.doorData.ZIP_OR_POSTAL;
      var request = {
        origin: start,
        destination: end,
        travelMode: google.maps.DirectionsTravelMode[site.locator.travelMode]
      };

      directionsService.route(request, function (response, status) {
        $('.dirError').remove();
        if (status === google.maps.DirectionsStatus.OK) {
          $(document).trigger('locator.directionsLoaded', [response]);
        } else if (status === google.maps.DirectionsStatus.NOT_FOUND) {
          // Couldn't find address, we need to show the user an error message
          $(
            '<ul class="error_messages dirError"><li>' +
              site.locator.nodes.dirInvalidAddress.text() +
              '</li></ul>'
          ).insertAfter('.directions-header');
        } else if (status === google.maps.DirectionsStatus.ZERO_RESULTS) {
          // No route between locations
          $(
            '<ul class="error_messages dirError"><li>' +
              site.locator.nodes.dirNoRoute.text() +
              '</li></ul>'
          ).insertAfter('.directions-header');
        } else {
          // Some other error that prevented us from getting directions.
          $(
            '<ul class="error_messages dirError"><li>' +
              site.locator.nodes.dirUnknownError.text() +
              '</li></ul>'
          ).insertAfter('.directions-header');
        }
      });
    }
  });

  var initDirectionsForm = function () {
    site.locator.nodes.dirSubmit.on('click', function (evt) {
      evt.preventDefault();
      // Check if From Address is empty, show or hide error accordingly
      if (
        site.locator.nodes.dirFromAddr.val() === 'undefined' ||
        site.locator.nodes.dirFromAddr.val() === ''
      ) {
        // Get text from missingStartAddr error node and insert it into the error element
        site.locator.nodes.dirErrors.text(site.locator.nodes.missingStartAddr.text());

        return;
      } else {
        site.locator.nodes.dirErrors.text('');
      }
      var args = {
        startAddress: site.locator.nodes.dirAddrInput.val()
      };
      var doorId = site.locator.nodes.dirDoorInput.val();

      args.doorData = site.locator.resultData.results[doorId];
      $(document).trigger('locator.submitDirectionsQuery', [args]);
    });
  };
  var initTravelMode = function () {
    $('.directions-form__transportation-mode-link[data-name]').on('click', function (e) {
      e.preventDefault();
      site.locator.travelMode = $(this).attr('data-name');
      site.locator.map.setMapTypeId(google.maps.MapTypeId.ROADMAP);
      $('.directions-form__transportation-mode-link[data-name]').removeClass('active');
      $(this).addClass('active');
      if ($('#to_address').val() !== '') {
        var args = {
          startAddress: site.locator.nodes.dirAddrInput.val()
        };
        var doorId = site.locator.nodes.dirDoorInput.val();

        args.doorData = site.locator.resultData.results[doorId];
        $(document).trigger('locator.submitDirectionsQuery', [args]);
      }
    });
  };

  site.locator.init = function () {
    site.locator.getDomNodes();
    site.locator.ui.getRBs();
    site.locator.ui.init();
  };

  /**
   * Event handlers
   */
  $(document).on('locator.directionsLoaded', function (e, param) {
    site.locator.ui.displayDirections(param);
  });

  $(document).on('locator.submitSearchQuery', function (evt, param) {
    site.locator.data.submitQuery(param);
  });

  $(document).on('locator.submitDirectionsQuery', function (evt, param) {
    site.locator.data.getDirections(param);
  });

  /**
   * Load the google maps api script asyncronously with a callback
   */
  Drupal.behaviors.storeLocatorV1 = {
    attach: function (context, settings) {
      var $sl = $('.store-locator-v1', context).once(),
        g_lang,
        g_map_js,
        googleScript,
        firstScript;
      var googleApiKey = settings.common?.google_api_key || '';

      if ($sl.length > 0) {
        g_lang = $sl.data('google-language') || '';
        g_lang = g_lang.substring(0, g_lang.indexOf('|'));
        g_map_js =
          window.location.protocol +
          '//maps.googleapis.com/maps/api/js?key=' +
          googleApiKey +
          '&libraries=geometry' +
          ($sl.hasClass('place-autocomplete') ? ',places' : '') +
          '&language=' +
          g_lang +
          '&v=3&callback=site.locator.init';
        googleScript = document.createElement('script');
        googleScript.async = true;
        googleScript.src = g_map_js;
        googleScript.type = 'text/javascript';
        firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode.insertBefore(googleScript, firstScript);
      }
    }
  };
})(
  jQuery,
  (window.site = window.site || {}),
  (window.generic = window.generic || {}),
  (window.google = window.google || {}),
  (window.addthisevent = window.addthisevent || {}),
  (window.tms_page_data = window.tms_page_data || {})
);
